import { getDisplayValueForType } from './tableUtil';

export const formatActivityTime = activityTime => {
  const today = new Date();
  const activityTimeInUserTimeZone = new Date(activityTime);

  const todayYear = today.getFullYear();
  const todayMonth = today.getMonth() + 1;
  const todayDay = today.getDate();
  const todayHours = today.getHours();
  const todayMinutes = today.getMinutes();

  const activityYear = activityTimeInUserTimeZone.getFullYear();
  const activityMonth = activityTimeInUserTimeZone.getMonth() + 1;
  const activityDay = activityTimeInUserTimeZone.getDate();
  const activityHours = activityTimeInUserTimeZone.getHours();
  const activityMinutes = activityTimeInUserTimeZone.getMinutes();

  if (todayYear > activityYear || todayMonth > activityMonth || todayDay > activityDay) {
    return getDisplayValueForType(activityTime, 'date');
  }

  if (((todayHours * 60) + todayMinutes) - ((activityHours * 60) + activityMinutes) < 60) {
    if ((todayHours - activityHours === 1) && (activityMinutes > todayMinutes)) {
      return `${((60 - activityMinutes) + todayMinutes)} minutes ago`;
    }

    if ((todayHours === activityHours) && (activityMinutes !== todayMinutes)) {
      return `${todayMinutes - activityMinutes} minutes ago`;
    }

    if (activityMinutes === todayMinutes) {
      return 'now';
    }
  }

  if (((todayHours * 60) + todayMinutes) - ((activityHours * 60) + activityMinutes) < 120) {
    return '1 hour ago';
  }

  return `${todayHours - activityHours} hours ago`;
};
